import { types } from '../constants';

export const openCreateCompanyDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_COMPANY_DIALOG,
  open
});

export const openEditCompanyDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_COMPANY_DIALOG,
  open
});

export const handleCompanyInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_COMPANY_FORM,
  value,
  inputFieldName
});

export const submitCompanyDispatch = (company, mode) => ({
  type: types.SUBMIT_COMPANY,
  company,
  mode
});

export const searchTermChangeForAllCompanies = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_COMPANIES,
  searchTerm
});

export const fetchAllCompaniesDispatch = () => ({
  type: types.FETCH_ALL_COMPANIES
});

export const compayEditClickDispatch = (company) => ({
  type: types.EDIT_COMPANY,
  company
});

export const showDeleteOrDeactiveCompanyDialogStateChanged = (
  open,
  companyId,
  status
) => ({
  type: types.DEACTIVATE_OR_DELETE_COMPANY_DIALOG,
  open,
  companyId,
  status
});

export const DeactiveOrDeleteCompanyDispatch = (company) => ({
  type: types.DEACTIVATE_OR_DELETE_COMPANY,
  company
});

export const fetchUserDetailsDispatch = (userEmail) => ({
  type: types.FETCH_USER_DETAILS,
  userEmail
});
